import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Lists from "./lists";
import PosOrder from "./form";
import { updateOrder } from "./slice/posSlice";

const PosSection = ({ type }) => {
  const dispatch = useDispatch();
  const posHeader = useSelector((state) => state.posSlice);

  // Store billType (B2B/B2C) in Redux so all child components can access it
  useEffect(() => {
    if (type) {
      dispatch(updateOrder({ billType: type }));
    }
  }, [type, dispatch]);

  return posHeader.isRestaurant ? <Lists /> : <PosOrder />;
};

export default PosSection;
